import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../lib/api";
import { ArrowLeft, Copy, Check, MessageCircle, Facebook, Twitter, Share2 } from "lucide-react";

const ShareBar = ({ newsId, title }) => {
  const [copied, setCopied] = useState(false);
  const url = `${window.location.origin}/api/share/berita/${newsId}`;
  const text = `${title}\n${url}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = url;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    }
    setCopied(true);
    toast.success("Link berita berhasil disalin");
    setTimeout(() => setCopied(false), 2000);
  };

  const open = (u) => window.open(u, "_blank", "noopener,width=640,height=540");
  const btn = "btn-pop inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-xs font-bold border border-slate-200 bg-white text-slate-600 hover:border-orange-400 hover:text-orange-600";

  return (
    <div className="flex flex-wrap items-center gap-2 mt-6" data-testid="berita-share-bar">
      <span className="inline-flex items-center gap-1.5 text-xs font-bold text-slate-400 mr-1 uppercase tracking-wider">
        <Share2 size={13} /> Bagikan
      </span>
      <button onClick={copy} className={btn} data-testid="berita-share-copy">
        {copied ? <Check size={13} className="text-emerald-600" /> : <Copy size={13} />} Salin Link
      </button>
      <button onClick={() => open(`https://wa.me/?text=${encodeURIComponent(text)}`)} className={btn} data-testid="berita-share-wa">
        <MessageCircle size={13} className="text-emerald-600" /> WhatsApp
      </button>
      <button onClick={() => open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`)} className={btn} data-testid="berita-share-fb">
        <Facebook size={13} className="text-blue-600" /> Facebook
      </button>
      <button onClick={() => open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(title)}&url=${encodeURIComponent(url)}`)} className={btn} data-testid="berita-share-tw">
        <Twitter size={13} className="text-sky-500" /> X / Twitter
      </button>
    </div>
  );
};

export default function BeritaDetail() {
  const { id } = useParams();
  const [news, setNews] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/news/${id}`).then((r) => setNews(r.data)).catch(() => setNotFound(true));
  }, [id]);

  if (notFound) return <div className="max-w-3xl mx-auto px-4 py-24 text-center text-slate-500" data-testid="berita-notfound">Berita tidak ditemukan. <Link to="/berita" className="text-orange-600 underline">Kembali</Link></div>;
  if (!news) return <div className="max-w-3xl mx-auto px-4 py-24 text-center text-slate-400">Memuat...</div>;

  return (
    <article className="max-w-3xl mx-auto px-4 py-14" data-testid="berita-detail-page">
      <Link to="/berita" className="inline-flex items-center gap-1.5 text-sm text-orange-600 font-medium mb-6" data-testid="berita-back-btn">
        <ArrowLeft size={15} /> Semua Berita
      </Link>
      <span className="block font-mono text-xs uppercase tracking-wider text-orange-600 mb-3">{news.category}</span>
      <h1 className="font-heading text-4xl sm:text-5xl font-bold text-slate-900 leading-tight">{news.title}</h1>
      <p className="font-mono text-sm text-slate-400 mt-4">{new Date(news.created_at).toLocaleDateString("id-ID", { weekday: "long", day: "numeric", month: "long", year: "numeric" })}</p>
      <ShareBar newsId={news.id} title={news.title} />
      {news.image_url && <img src={news.image_url} alt={news.title} className="w-full rounded border border-slate-200 my-8" />}
      <div className="text-slate-700 leading-relaxed whitespace-pre-line mt-6 text-reading">{news.content}</div>
    </article>
  );
}
